<template>
  <NewTask
    taskType="financial_document"
    :docList="['Financial Document']"
  >
  </NewTask>
</template>

<script>
import axios from 'axios'
import NewTask from '@/components/NewTask.vue';

export default {
  components: {
    NewTask
  },
}
</script>
